import React from "react";
import { SITE_CONFIG } from "../config/siteConfig";

// Floating WhatsApp button with accessibility and best practices
// - Uses a wa.me link so no external scripts are required
// - Opens in a new tab with rel="noopener noreferrer"
// - Accessible aria-label and keyboard focus styles
// - Uses Tailwind utility classes (project already includes Tailwind)

function normalizePhone(phone) {
    if (!phone) return phone;
    // keep only digits and plus sign
    return phone.replace(/[^+0-9]/g, "");
}

export default function WhatsAppButton({ message = "" }) {
    const raw = normalizePhone(SITE_CONFIG.phone || "");
    // wa.me requires phone without '+' sign
    const waPhone = raw.startsWith("+") ? raw.slice(1) : raw;
    const textParam = message ? `?text=${encodeURIComponent(message)}` : "";
    const href = waPhone ? `https://wa.me/${waPhone}${textParam}` : "https://wa.me/";

    return (
        <a href={href} target="_blank" rel="noopener noreferrer"
            aria-label="Chat on WhatsApp" title="Chat on WhatsApp"
            className={
                // fixed, bottom-right, accessible focus ring, nice green gradient
                "fixed bottom-6 right-6 z-50 shadow-lg rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-400 " +
                "bg-gradient-to-b from-green-500 to-green-600 p-4 flex items-center justify-center text-white hover:scale-105 transition-transform"
            }>
            {/* WhatsApp SVG icon (simple, no external dependency) */}
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                <path d="M20.52 3.48A11.94 11.94 0 0012 0C5.37 0 .03 5.34.03 11.97c0 2.11.55 4.17 1.6 6.01L0 24l6.27-1.63A11.94 11.94 0 0012 24c6.63 0 12-5.34 12-12 0-1.96-.48-3.8-1.48-5.52z" fill="#25D366" />
                <path d="M17.45 14.38c-.29-.15-1.71-.84-1.98-.93-.27-.1-.47-.15-.67.15s-.77.93-.94 1.12c-.17.18-.35.21-.64.07-.29-.15-1.23-.45-2.34-1.45-.87-.77-1.45-1.72-1.62-2.01-.17-.29-.02-.45.13-.6.13-.13.29-.35.44-.52.15-.17.2-.29.3-.48.1-.18.05-.34-.02-.49-.07-.15-.67-1.6-.92-2.2-.24-.57-.49-.49-.67-.5l-.57-.01c-.18 0-.47.07-.72.34-.25.27-.95.93-.95 2.27 0 1.34.97 2.64 1.11 2.82.13.18 1.92 2.94 4.65 4.12 3.22 1.4 3.22.93 3.79.87.48-.06 1.56-.63 1.78-1.24.22-.6.22-1.11.15-1.23-.07-.13-.26-.18-.55-.33z" fill="#FFF" />
            </svg>
        </a>
    );
}

